import type { EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import type ExtensionAPI from 'echarts/lib/core/ExtensionAPI';
import type { CoordinateSystemMaster } from 'echarts/lib/coord/CoordinateSystem';
import {
  type FlagInfo,
  prepareFlagInfoList,
  shiftLayoutOnY as shiftFlagLayoutOnY
} from './FlagLayoutHelper';
import {
  getCurvedPointerLayoutListPrepareInput,
  prepareCurvedPointerInfoList,
  shiftLayoutOnY as shiftCurvedPointerLayoutOnY
} from './curvedPointerLayoutHelper';

function adjustFlagPosition(chart: ExtensionAPI) {
  const ecModel = chart.getModel();
  const dvMarkerModel = ecModel
    .getSeriesByType('custom')
    .filter(item => item.option?.dvType === 'dvMarker' && item.option?.dvMarkType === 'flag');

  const gridFlagMarkerMap = new Map<
    CoordinateSystemMaster,
    {
      needHideOverlap: boolean;
      flagList: FlagInfo[];
      customLayoutHandler?: Parameters<typeof shiftFlagLayoutOnY>['4'];
    }
  >();

  dvMarkerModel.forEach(markModel => {
    const gridModel = markModel.coordinateSystem.master;
    const flagInfoList = prepareFlagInfoList(markModel);
    const currHideOverlap = !!markModel.get('hideOverlap');
    const flagLayoutHandler = markModel.get('flagLayoutHandler') as
      | Parameters<typeof shiftFlagLayoutOnY>['4']
      | undefined;

    if (gridFlagMarkerMap.has(gridModel)) {
      gridFlagMarkerMap.get(gridModel).flagList.push(...flagInfoList);
      gridFlagMarkerMap.get(gridModel).needHideOverlap =
        gridFlagMarkerMap.get(gridModel).needHideOverlap || currHideOverlap;
      gridFlagMarkerMap.get(gridModel).customLayoutHandler =
        flagLayoutHandler ?? gridFlagMarkerMap.get(gridModel).customLayoutHandler;
    } else {
      gridFlagMarkerMap.set(gridModel, {
        flagList: flagInfoList,
        needHideOverlap: currHideOverlap,
        customLayoutHandler: flagLayoutHandler
      });
    }
  });

  gridFlagMarkerMap.forEach(({ flagList, needHideOverlap, customLayoutHandler }, gridModel) => {
    const gridRect = gridModel.getRect();
    shiftFlagLayoutOnY(
      flagList,
      gridRect.y,
      gridRect.y + gridRect.height,
      needHideOverlap,
      customLayoutHandler
    );
  });
}

function adjustCurvedPointerPosition(chart: ExtensionAPI) {
  const ecModel = chart.getModel();
  const dvMarkerModel = ecModel
    .getSeriesByType('custom')
    .filter(
      item => item.option?.dvType === 'dvMarker' && item.option?.dvMarkType === 'curvedPointer'
    );
  dvMarkerModel.forEach(markModel => {
    const markView = chart.getViewOfSeriesModel(markModel);
    const gridRect = markModel.coordinateSystem.master.getRect();
    const input = getCurvedPointerLayoutListPrepareInput(markView);
    const curvedPointerInfoList = prepareCurvedPointerInfoList(input);
    shiftCurvedPointerLayoutOnY(curvedPointerInfoList, gridRect.y, gridRect.y + gridRect.height);
  });
}

export function dvMarkerExtensionInstall(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('series:afterupdate', (_, chart) => {
    // todo目前为flag标记特有的位置调整扩展
    adjustFlagPosition(chart);
    adjustCurvedPointerPosition(chart);
  });
}
